define('TescoMobile_Checkout/js/checkout-data-mixin',['jquery', 'Magento_Customer/js/customer-data', 'mageUtils', 'mage/utils/wrapper', 'jquery/jquery-storageapi'], function ($, storage, utils, wrapper) {
  'use strict';

  var cacheKey = 'tm-checkout-data',
    saveData = function (data) {
      storage.set(cacheKey, data);
    },
    initData = function () {
      return {
        previousAddress: null,
        marketingPreferences: null,
        clubcard: null,
        monthlyPaymentDirectDebit: null,
        monthlyPaymentCard: null,
        cartPayment: null,
        customer: null
      };
    },
    getData = function () {
      let data = storage.get(cacheKey)();
      if ($.isEmptyObject(data)) {
        data = $.initNamespaceStorage('mage-cache-storage').localStorage.get(cacheKey);
        if ($.isEmptyObject(data)) {
          data = initData();
          saveData(data);
        }
      }
      return data;
    },
    mixin = {
      setPreviousAddress: function (data) {
        const obj = getData();
        obj.previousAddress = data;
        saveData(obj);
      },
      getPreviousAddress: function () {
        return getData().previousAddress;
      },
      setMarketingPreferences: function (data) {
        const obj = getData();
        obj.marketingPreferences = data;
        saveData(obj);
      },
      getMarketingPreferences: function () {
        return getData().marketingPreferences;
      },
      setMonthlyPaymentDirectDebit: function (data) {
        const obj = getData();
        obj.monthlyPaymentDirectDebit = data;
        saveData(obj);
      },
      getMonthlyPaymentDirectDebit: function () {
        return getData().monthlyPaymentDirectDebit;
      },
      setMonthlyPaymentCard: function (data) {
        const obj = getData();
        obj.monthlyPaymentCard = data;
        saveData(obj);
      },
      getMonthlyPaymentCard: function () {
        return getData().monthlyPaymentCard;
      },
      setCardPayment: function (data) {
        const obj = getData();
        obj.cartPayment = data;
        saveData(obj);
      },
      getCartPayment: function () {
        return getData().cartPayment;
      },
      setCustomer: function (data) {
        const obj = getData();
        obj.customer = data;
        saveData(obj);
      },
      getCustomer: function () {
        return getData().customer;
      }
    };
  return function (target) {
    return wrapper.extend(target, mixin);
  };
});

